import { Controller } from "@hotwired/stimulus"

/**
 * Marks changelog entries the user hasn't opened as unread. Visited entry slugs
 * are stored in localStorage; on connect the unread marker is cleared for
 * already-visited entries, and opening an entry records it as visited.
 *
 * Rendered by ChangelogHighlightsComponent. Markup is neutral on purpose; the
 * host container themes it.
 */
export default class extends Controller {
  static targets = ["item"]
  static values = {
    storageKey: { type: String, default: "gobierto:changelog:visited" }
  }

  connect() {
    const visited = this.readVisited()
    this.itemTargets.forEach((item) => {
      if (visited.includes(item.dataset.slug)) this.markRead(item)
    })
  }

  visit(event) {
    const slug = event.currentTarget.dataset.slug
    if (!slug) return

    const visited = this.readVisited()
    if (!visited.includes(slug)) {
      visited.push(slug)
      this.writeVisited(visited)
    }
    this.markRead(event.currentTarget)
  }

  markRead(item) {
    const unread = item.querySelector('[data-changelog-highlights-target="unread"]')
    if (unread) unread.classList.add("invisible")
  }

  readVisited() {
    try {
      const raw = window.localStorage.getItem(this.storageKeyValue)
      const parsed = raw ? JSON.parse(raw) : []
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  }

  writeVisited(visited) {
    try {
      window.localStorage.setItem(this.storageKeyValue, JSON.stringify(visited))
    } catch {
      // Ignore storage failures (private mode, quota exceeded, ...).
    }
  }
}
